function getNavigations(roleId) {
  let navigations = [];
  if (roleId === '2') {
    navigations = [
      {
        icon: 'insights',
        name: 'Dashboard',
        path: '/dashboard',
      },
      {
        icon: 'dashboard',
        name: 'User Tasks',
        path: '/user-dashboard',
      },
      {
        icon: 'contact_phone',
        name: 'Leads',
        path: '/lead',
      },
      {
        icon: 'assignment_turned_in',
        name: 'Opportunities',
        path: '/opportunities',
      },
      {
        icon: 'house',
        name: 'Properties',
        path: '/property',
      },
      {
        icon: 'apartment',
        name: 'Projects',
        path: '/projects',
      },
      {
        icon: 'settings',
        name: 'Util',
        children: [
          {
            icon: 'location_city',
            name: 'Cities',
            path: '/cities',
          },
          {
            icon: 'emoji_objects',
            name: 'Amenities',
            path: '/amenities',
          },
          {
            icon: 'people',
            name: 'Contacts',
            path: '/contact',
          },
          {
            icon: 'manage_accounts',
            name: 'Users',
            path: '/users',
          },
          {
            icon: 'alt_route',
            name: 'Lead Routing',
            path: '/lead-routing',
          },
          {
            icon: 'receipt_long',
            name: 'Logs',
            path: '/logs',
          },
          {
            icon: 'notifications_active',
            name: 'Notification Tester',
            path: '/notification-test',
          },
        ],
      },
      {
        icon: 'logout',
        name: 'Logout',
        path: '/master/logout',
      },
    ];
  }
  else {
    navigations = [
      {
        icon: 'dashboard',
        name: 'Dashboard',
        path: '/user-dashboard',
      },
      {
        icon: 'contact_phone',
        name: 'Leads',
        path: '/lead',
      },
      {
        icon: 'assignment_turned_in',
        name: 'Opportunities',
        path: '/opportunities',
      },
      {
        icon: 'house',
        name: 'Properties',
        path: '/property',
      },
      {
        icon: 'apartment',
        name: 'Projects',
        path: '/projects',
      },
      {
        icon: 'settings',
        name: 'Util',
        children: [
          {
            icon: 'location_city',
            name: 'Cities',
            path: '/cities',
          },
          {
            icon: 'emoji_objects',
            name: 'Amenities',
            path: '/amenities',
          },
          {
            icon: 'people',
            name: 'Contacts',
            path: '/contact'
          }
        ],
      },
      {
        icon: 'logout',
        name: 'Logout',
        path: '/master/logout',
      },
    ];
  }
  return navigations;
}

export { getNavigations };